export enum GygActivityStatusEnum {
    DRAFT = 'draft',
    PUBLISHED = 'published',
}
